<template>
	<div>
		<v-combobox :items="items" v-model="model" :label="$t('htmSelect.whyAgian')">
         
		</v-combobox>
    
	</div>
</template>

<script>
	export default {
		name: "htm-select",
		props: ["value"],
		components: {},
		data() {
			return {
				items: [
					this.$t("htmSelect.whyAgian"),
					this.$t("htmSelect.noAttention"),
					this.$t("htmSelect.genericBath"),
					this.$t("htmSelect.surveyNotComplete"),
					this.$t("htmSelect.missingHeight"),
					this.$t("htmSelect.mistakeInLowering"),
					this.$t("htmSelect.mistakeWithHeightFromFloor"),
					this.$t("htmSelect.mistakeWithHeightFromFloorPlaster"),
					this.$t("htmSelect.mistakeAngels"),
					this.$t("htmSelect.sinkMistakeLocation"),
					this.$t("htmSelect.notSurveyedBalcony"),
					this.$t("htmSelect.notSurveyedSewageOpening"),
					this.$t("htmSelect.sewagePipeline"),
					this.$t("htmSelect.windowNotSurvey"),
					this.$t("htmSelect.spaceNotSurvey"),
					this.$t("htmSelect.notByMarkWall"),
					this.$t("htmSelect.gasPoint"),
					this.$t("htmSelect.kitchenSpace"),
					this.$t("htmSelect.ceiling"),
					this.$t("htmSelect.nisaNotSurvey"),
					this.$t("htmSelect.leverNotFound"),
					this.$t("htmSelect.sinkSpot"),
					this.$t("htmSelect.exitToBalconyNotFound"),
					this.$t("htmSelect.plasterWallNotFound"),
					this.$t("htmSelect.picturesNotFound"),
					this.$t("htmSelect.acNotFound"),
					this.$t("htmSelect.centerElectricityNotFound"),
					this.$t("htmSelect.surveyMistake"),
					this.$t("htmSelect.wallNotFound")
				],

			};
		},
		computed: {
			model: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				}
			}
		},
		methods: {},
		watch: {},
		created() {
		},
		mounted() {
		},
		updated() {
		},
		destroyed() {
		}
	};
</script>

<style scoped>

</style>
